/* eslint-disable no-underscore-dangle */
import { $applyNodeReplacement, TextNode } from 'lexical'

export class FilterNode extends TextNode {
  static getType() {
    return 'filter'
  }

  static clone(node) {
    return new FilterNode(node.__text, node.__valueId, node.__key)
  }

  // eslint-disable-next-line no-useless-constructor
  constructor(text, valueId, key) {
    super(text, key)
    this.__valueId = valueId
  }

  createDOM(config) {
    const element = super.createDOM(config)
    element.classList.add(config.theme.filter)
    return element
  }

  getValueId() {
    return this.__valueId
  }

  static importJSON(serializedNode) {
    const node = $createFilterNode(serializedNode.text, serializedNode.valueId)
    node.setFormat(serializedNode.format)
    node.setDetail(serializedNode.detail)
    node.setMode(serializedNode.mode)
    node.setStyle(serializedNode.style)
    return node
  }

  exportJSON() {
    return {
      ...super.exportJSON(),
      valueId: this.getValueId(),
      type: 'filter',
    }
  }

  canInsertTextBefore() {
    return true
  }

  isTextEntity() {
    return true
  }
}

export function $createFilterNode(text = '', valueId) {
  // Optional valueId: for storing the id of the value of the filter (such as the contact email)
  // then we can replace the value with the id on submit
  return $applyNodeReplacement(new FilterNode(text, valueId))
}

export function $isFilterNode(node) {
  return node instanceof FilterNode
}

export function $isFromFilter(node) {
  if (!node) return false
  return $isFilterNode(node) && node.__text.startsWith('from:')
}
